import API from "./API";

export const uploadNotificationImageApi = async (payload) => {
  try {
    const formData = new FormData();
    formData.append("file", payload.file);
    const response = await API.post(
      `/notifications/image`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};